export default "__VITE_ASSET__CyQGrrGs__"